import { User } from "../shared/auth.model";

export const AUTH_KEY = 'auth';
export interface AuthState {
  userData?: User;
}

export const initialState: AuthState = {};
